export default __webpack_public_path__ + "static/media/CareEvent2-min.01d0eddd.png";